// Переключение анкет гостей: по табам гостей и кнопкам «Пред./След. анкета».
//
// Заложено с расчётом на доработку:
//  - переход между анкетами идёт через один метод go(index), вокруг которого
//    позже можно навесить валидацию (canLeave) и сохранение (onLeave/onEnter);
//  - о каждом переключении сообщаем CustomEvent("application:change"), чтобы
//    будущие модули (валидация, автосохранение, прогресс) подписывались, а не
//    правили этот файл;
//  - DOM-привязки (табы/панели/кнопки) собраны в одном месте.

import { showAlert } from "../Popup/Popup-alert.js";

document.querySelectorAll(".visa-order-applications").forEach(initVisaOrderApplications);
document.querySelectorAll(".visa-order-application__question").forEach(initQuestionDetails);
document.querySelectorAll("form.visa-order-application").forEach(initOrderAutoSave);
document.querySelectorAll("form.visa-order-application").forEach(initFileFields);
document.querySelectorAll(".visa-order-applications").forEach(initSubmit);
document.querySelectorAll(".visa-order-applications").forEach(initAuthorEmail);
document.querySelectorAll(".visa-order-applications").forEach(initApplicationManage);

// Вопрос «Да/Нет»: поле с подробностями показываем только при ответе «Да».
// Работает независимо от переключения анкет (скрытые панели тоже синхронизированы).
function initQuestionDetails(question) {
	const details = question.querySelector(".visa-order-application__question-details");
	const radios = question.querySelectorAll(".form-radio-btn__input");
	if (!details || !radios.length) return;

	const sync = () => {
		const yes = question.querySelector('.form-radio-btn__input[value="1"]');
		details.classList.toggle("is-visible", Boolean(yes && yes.checked));
	};

	radios.forEach((radio) => radio.addEventListener("change", sync));
	sync();
}

function initVisaOrderApplications(form) {
	const tabs = Array.from(form.querySelectorAll(".visa-order-applications__guest"));
	const panels = Array.from(form.querySelectorAll(".visa-order-applications__panel"));
	if (!tabs.length || !panels.length) return;

	const count = Math.min(tabs.length, panels.length);
	const prevBtn = form.querySelector("[data-application-prev]");
	const nextBtn = form.querySelector("[data-application-next]");

	// стартовая анкета — активный таб, иначе первая
	let current = tabs.findIndex((tab) => tab.classList.contains("active"));
	if (current < 0 || current >= count) current = 0;

	// Хук для будущей валидации: вернуть false, чтобы запретить уход с анкеты.
	function canLeave(/* from, to */) {
		return true;
	}

	function go(index) {
		const target = Math.max(0, Math.min(count - 1, index));
		if (target === current) return;
		if (!canLeave(current, target)) return;

		current = target;
		render();

		form.dispatchEvent(
			new CustomEvent("application:change", {
				bubbles: true,
				detail: { index: current, total: count },
			})
		);
	}

	function render() {
		tabs.forEach((tab, i) => tab.classList.toggle("active", i === current));
		panels.forEach((panel, i) => {
			const isActive = i === current;
			panel.classList.toggle("is-active", isActive);
			panel.hidden = !isActive;
		});
		syncNav();
	}

	function syncNav() {
		// при одной анкете кнопок нет вовсе (их не рендерит XSL) — ветка остаётся
		// страховкой на случай, если разметка окажется без этого условия
		const single = count <= 1;
		if (prevBtn) prevBtn.disabled = single || current === 0;
		if (nextBtn) nextBtn.disabled = single || current === count - 1;
	}

	// Скролл к верху блока анкет. Отступ под шапку берём из CSS scroll-margin-top
	// (задан как высота шапки в .styl) — так вертикальная привязка в одном месте.
	// Плавность — через Lenis, если он активен (как в _Common/app.js), иначе нативно.
	function scrollToTop() {
		const smt = parseFloat(getComputedStyle(form).scrollMarginTop) || 0;
		const top = form.getBoundingClientRect().top + window.pageYOffset - smt;
		if (window.lenis) window.lenis.scrollTo(top);
		else window.scrollTo({ top, behavior: "smooth" });
	}

	tabs.forEach((tab, i) => {
		const trigger = tab.querySelector(".visa-order-applications__guest-select") || tab;
		trigger.addEventListener("click", () => go(i));
	});

	// Кнопки «Пред./След. анкета» уводят к концу панели — после переключения
	// возвращаем взгляд к верху анкет (табы + начало новой анкеты).
	if (prevBtn) prevBtn.addEventListener("click", () => { go(current - 1); scrollToTop(); });
	if (nextBtn) nextBtn.addEventListener("click", () => { go(current + 1); scrollToTop(); });

	render();
}

// ── Автосейв анкеты ──────────────────────────────────────────────────────────
// Каждая анкета — отдельная <form>. По изменению любого поля (debounce 600мс)
// отправляем её целиком: VForm сохраняет одного заявителя, сервер возвращает
// пересчитанный статус — обновляем таб. Дата шлёт change из form-date.js.
const ORDER_MID = 3; // mod_order в таблице modules

function initOrderAutoSave(form) {
	const formId = form.dataset.formId;
	if (!formId) return;

	// change — дискретное событие (селект — при выборе, инпут — при блюре), поэтому
	// debounce не нужен: сохраняем сразу. Защищаемся лишь от наложения запросов —
	// если правка пришла во время сохранения, делаем ещё один проход после.
	let saving = false;
	let pending = false;
	async function run() {
		if (saving) { pending = true; return; }
		saving = true;
		await saveApplication(form, formId);
		saving = false;
		if (pending) { pending = false; run(); }
	}
	form.addEventListener("change", run);
}

async function saveApplication(form, formId) {
	const data = new FormData(form);
	data.set("action", "saveForm");
	data.set("form_id", formId);

	// Файлы, уезжающие этим запросом: по ответу либо фиксируем (реальная ссылка,
	// очистка input), либо откатываем и подсвечиваем ошибку.
	const pendingFiles = Array.from(form.querySelectorAll("input[type=file][data-file-input]"))
		.filter((input) => input.files && input.files.length);

	try {
		const res = await fetch(`/ajax.php?mid=${ORDER_MID}`, { method: "POST", body: data });
		const json = await res.json();
		applyFileResult(form, pendingFiles, json);
		if (json.success) {
			setApplicationTabState(formId, tabStateFromStatus(json.status));
		} else {
			// Сервер мог сохранить остальные поля и вернуть статус — тогда таб по статусу,
			// а ошибка — на конкретных полях. Иначе таб красный.
			setApplicationTabState(formId, typeof json.status === "number" ? tabStateFromStatus(json.status) : "error");
			console.warn("[order] анкета не сохранена:", json.field_errors || json.errors || json.error);
			showAlert(json.error || "Не удалось сохранить анкету. Попробуйте ещё раз.");
		}
	} catch (e) {
		console.error("[order] ошибка автосохранения:", e);
		// Сервер не ответил (сеть / 500 / не-JSON): файлы не считаем загруженными.
		pendingFiles.forEach((input) => {
			rollbackFile(input);
			setFileError(input, "Сервер не ответил — файл не загружен. Попробуйте ещё раз.");
		});
		setApplicationTabState(formId, "error");
		showAlert("Не удалось сохранить анкету: сервер не ответил. Попробуйте ещё раз.");
	}
}

// Итог загрузки файлов по ответу сервера. json.files — {fle_x: {path, filename}}
// сохранённых, json.field_errors — {fle_x: 'текст'} проблемных.
function applyFileResult(form, pendingFiles, json) {
	const saved = json.files || {};
	const errors = json.field_errors || {};
	pendingFiles.forEach((input) => {
		const name = input.dataset.fileInput;
		if (errors[name]) {
			rollbackFile(input);
			setFileError(input, errors[name]);
		} else if (saved[name] && saved[name].path) {
			commitFile(input, saved[name].filename, saved[name].path);
		} else if (!json.success) {
			// общий сбой сохранения — файл на сервер не попал
			rollbackFile(input);
			setFileError(input, "Файл не загружен: анкета не сохранилась");
		}
	});
	// ошибки полей, к которым файл не прикладывался в этом запросе (напр. серверная
	// проверка уже лежащего файла) — тоже показать
	Object.keys(errors).forEach((name) => {
		if (pendingFiles.some((i) => i.dataset.fileInput === name)) return;
		const input = form.querySelector(`input[type=file][data-file-input="${name}"]`);
		if (input) setFileError(input, errors[name]);
	});
}

// ── Файлы анкеты ─────────────────────────────────────────────────────────────
// Выбор файла: проверяем формат (accept) и размер (data-max-size) ДО отправки —
// невалидный файл не уходит на сервер (stopPropagation в capture-фазе: до
// автосейва, который слушает change на form в bubble-фазе). Валидный — оптимистичный
// UI (имя + локальное превью), сам файл уезжает общим автосейвом; по ответу
// commitFile/rollbackFile (см. applyFileResult). Удаление: AJAX deleteFile.
function initFileFields(form) {
	const formId = form.dataset.formId;
	if (!formId) return;

	form.addEventListener("change", (e) => {
		const input = e.target.closest("input[type=file][data-file-input]");
		if (!input) return;
		const file = input.files && input.files[0];
		if (!file) return;

		const error = validateFile(input, file);
		if (error) {
			e.stopPropagation();
			rollbackFile(input);
			setFileError(input, error);
			return;
		}

		clearFileError(input);
		rememberFile(input);
		showFile(input.closest(".form-file"), file.name, URL.createObjectURL(file));
	}, true);

	// удаление файла
	form.addEventListener("click", (e) => {
		const btn = e.target.closest("[data-file-delete]");
		if (!btn) return;
		e.preventDefault();
		deleteFile(form, formId, btn);
	});
}

// Перевести поле в состояние «загружен»: имя + ссылка. Кнопка «Загрузить»→«Заменить»
// (текст+иконка icon_refresh) и зелёная рамка — переключаются CSS по .is-uploaded.
function showFile(formFile, name, href) {
	if (!formFile) return;
	formFile.classList.add("is-uploaded");
	const text = formFile.querySelector(".form-file__name-text");
	const link = formFile.querySelector(".form-file__name-link");
	if (text) text.textContent = name;
	if (link && href) link.setAttribute("href", href);
}

// Сбросить поле в состояние «пусто»: очистить input и имя. Кнопка/рамка — CSS.
function clearFile(formFile) {
	if (!formFile) return;
	formFile.classList.remove("is-uploaded");
	const input = formFile.querySelector("input[type=file]");
	const text = formFile.querySelector(".form-file__name-text");
	const link = formFile.querySelector(".form-file__name-link");
	if (input) input.value = "";
	if (text) text.textContent = "";
	if (link) link.removeAttribute("href");
}

// Клиентская проверка файла по атрибутам input (accept — расширения через запятую,
// data-max-size — байты; оба ставит вёрстка из /module/files). → текст ошибки или "".
function validateFile(input, file) {
	const accept = (input.getAttribute("accept") || "")
		.split(",").map((s) => s.trim().toLowerCase()).filter(Boolean);
	const ext = (file.name.match(/\.([^.]+)$/) || [, ""])[1].toLowerCase();
	if (accept.length && !accept.includes("." + ext)) {
		const list = Array.from(new Set(accept.map((a) => a.replace(/^\./, "").replace(/^jpeg$/, "jpg").toUpperCase())));
		return `Недопустимый формат${ext ? ` (${ext})` : ""}. Допустимые: ${list.join(", ")}`;
	}
	const max = parseInt(input.dataset.maxSize, 10);
	if (max > 0 && file.size > max)
		return `Файл слишком большой: максимальный размер — ${input.dataset.maxLabel || Math.round(max / 1048576) + " МБ"}`;
	return "";
}

// Запомнить серверное состояние поля перед оптимистичным показом нового файла —
// чтобы при ошибке загрузки вернуть его (rollbackFile), а не оставлять «загружен».
function rememberFile(input) {
	if (input.dataset.prevKnown) return; // уже помним (повторный выбор до ответа)
	const formFile = input.closest(".form-file");
	const link = formFile && formFile.querySelector(".form-file__name-link");
	input.dataset.prevKnown = "1";
	input.dataset.prevUploaded = formFile && formFile.classList.contains("is-uploaded") ? "1" : "";
	input.dataset.prevName = (formFile && formFile.querySelector(".form-file__name-text")?.textContent) || "";
	input.dataset.prevHref = (link && link.getAttribute("href")) || "";
}

// Файл сохранён на сервере: реальная ссылка вместо blob, input очищаем (иначе он
// уезжал бы повторно с каждым следующим автосейвом), «предыдущее состояние» = текущее.
function commitFile(input, filename, path) {
	const formFile = input.closest(".form-file");
	showFile(formFile, filename, path);
	input.value = "";
	delete input.dataset.prevKnown;
	clearFileError(input);
}

// Файл НЕ загружен: очистить input и вернуть прошлое состояние поля (старый файл
// или «пусто») — значение в поле не остаётся.
function rollbackFile(input) {
	const formFile = input.closest(".form-file");
	input.value = "";
	if (input.dataset.prevKnown) {
		if (input.dataset.prevUploaded) {
			showFile(formFile, input.dataset.prevName, input.dataset.prevHref);
		} else {
			clearFile(formFile);
		}
		delete input.dataset.prevKnown;
	} else if (formFile && (formFile.querySelector(".form-file__name-link")?.getAttribute("href") || "").startsWith("blob:")) {
		clearFile(formFile);
	}
}

// Ошибка поля: .is-invalid на .form__item (красная рамка, CSS) + текст в .form__item-mistake.
function setFileError(input, message) {
	const item = input.closest(".form__item");
	if (!item) return;
	item.classList.add("is-invalid");
	const mistake = item.querySelector(".form__item-mistake");
	if (mistake) mistake.textContent = message || "Файл не загружен";
}

function clearFileError(input) {
	const item = input.closest(".form__item");
	if (!item) return;
	item.classList.remove("is-invalid");
	const mistake = item.querySelector(".form__item-mistake");
	if (mistake) mistake.textContent = "";
}

async function deleteFile(form, formId, btn) {
	const field = btn.dataset.fileDelete;
	const formFile = btn.closest(".form-file");
	const data = new FormData();
	data.set("action", "deleteFile");
	data.set("form_id", formId);
	data.set("field", field);

	try {
		const res = await fetch(`/ajax.php?mid=${ORDER_MID}`, { method: "POST", body: data });
		const json = await res.json();
		if (json.success) {
			clearFile(formFile);
			const input = formFile && formFile.querySelector("input[type=file]");
			if (input) { delete input.dataset.prevKnown; clearFileError(input); }
			setApplicationTabState(formId, tabStateFromStatus(json.status));
		} else {
			console.warn("[order] файл не удалён:", json.error);
			showAlert(json.error || "Не удалось удалить файл");
		}
	} catch (e) {
		console.error("[order] ошибка удаления файла:", e);
		showAlert("Не удалось удалить файл: сервер не ответил");
	}
}

// Статус таба: ready (зелёный «Заполнено») / error (красный) / '' (серый «Ожидает»).
// Иконку и текст статуса переключает CSS по классу .ready/.error — здесь только класс.
// Класс .active (выбранный таб) не трогаем.
// status с сервера (0 ожидает / 1 заполнено / 2 частично) → класс-состояние таба.
function tabStateFromStatus(status) {
	return status === 1 ? "ready" : status === 2 ? "partial" : "";
}

function setApplicationTabState(formId, state) {
	const tab = document.querySelector(`.visa-order-applications__guest[data-form-id="${formId}"]`);
	if (!tab) return;
	tab.classList.remove("ready", "partial", "error");
	if (state) tab.classList.add(state);

	// Готовность анкеты могла измениться — пересчитать gate финальной кнопки.
	document.dispatchEvent(new CustomEvent("application:status"));
}

// ── Финальная отправка (шаг «Анкеты» → «Проверка») ───────────────────────────
// Кнопка разблокируется, когда отмечены все 3 согласия И все анкеты готовы (.ready).
// Сервер всё равно перепроверяет (submitAllForms) и при успехе отдаёт redirect.
function initSubmit(root) {
	const submitBtn = root.querySelector(".visa-order-applications__submit");
	if (!submitBtn) return;

	const agreements = Array.from(root.querySelectorAll(".visa-order-applications__agreements .form-check__input"));
	const tabs = Array.from(root.querySelectorAll(".visa-order-applications__guest"));

	function update() {
		const allAgreed = agreements.length > 0 && agreements.every((c) => c.checked);
		const allReady = tabs.length > 0 && tabs.every((t) => t.classList.contains("ready"));
		submitBtn.disabled = !(allAgreed && allReady);
	}

	agreements.forEach((c) => c.addEventListener("change", update));
	document.addEventListener("application:status", update);
	submitBtn.addEventListener("click", () => {
		if (!submitBtn.disabled) submitAllForms(root, submitBtn);
	});

	update();
}

// Контактный e-mail заказа («Email заполняющего»). Поле вне анкет-форм, поэтому
// сохраняем отдельным запросом по change (в колонку STR_EMAIL, не трогая гейт).
function initAuthorEmail(root) {
	const blockId = root.dataset.blockId;
	// Поле e-mail вынесено в шапку заказа (вне .visa-order-applications), ищем по документу.
	const input = document.querySelector("#author-email");
	if (!blockId || !input) return;

	input.addEventListener("change", async () => {
		const data = new FormData();
		data.set("action", "saveOrderEmail");
		data.set("block_id", blockId);
		data.set("email", input.value.trim());
		try {
			const res = await fetch(`/ajax.php?mid=${ORDER_MID}`, { method: "POST", body: data });
			const json = await res.json();
			if (!json.success) console.warn("[order] email не сохранён:", json.error);
		} catch (e) {
			console.error("[order] ошибка сохранения email:", e);
		}
	});
}

async function submitAllForms(root, btn) {
	const blockId = root.dataset.blockId;
	const span = btn.querySelector("span");
	const orig = span ? span.textContent : "";

	const data = new FormData();
	data.set("action", "submitAllForms");
	data.set("block_id", blockId);

	btn.disabled = true;
	if (span) span.textContent = "Отправка…";

	try {
		const res = await fetch(`/ajax.php?mid=${ORDER_MID}`, { method: "POST", body: data });
		const json = await res.json();
		if (json.success) {
			window.location.href = json.redirect || `/order/${blockId}/?step=2`;
			return;
		}
		console.warn("[order] отправка отклонена:", json.error);
		showAlert(json.error || "Не удалось отправить анкеты");
	} catch (e) {
		console.error("[order] ошибка отправки:", e);
	}

	if (span) span.textContent = orig;
	btn.disabled = false;
}

// ── Добавление / удаление анкеты (гостя) ─────────────────────────────────────
// Добавление и удаление меняют число анкет → сервер пересчитывает count/quote и
// отдаёт redirect; страницу перезагружаем (табы/цена/шапка обновятся серверно).
// Удаление подтверждается общим попапом application-delete (открывает Popup.js);
// здесь запоминаем, какую анкету удаляем, и вешаем обработчик на кнопку подтверждения.
function initApplicationManage(root) {
	const blockId = root.dataset.blockId;
	if (!blockId) return;

	const addBtn = root.querySelector(".visa-order-applications__guests-add");
	if (addBtn) addBtn.addEventListener("click", () => addApplication(blockId, addBtn));

	let pendingDeleteId = null;
	// последняя анкета: удалять заказ без единой анкеты незачем, поэтому уносим его
	// целиком. Попап в этом случае показывает другой текст (класс .is-last).
	let deletesOrder = false;
	const popup = document.querySelector('[data-popup-name="application-delete"]');

	root.querySelectorAll(".visa-order-applications__guest-remove").forEach((btn) => {
		btn.addEventListener("click", () => {
			const li = btn.closest("[data-form-id]");
			pendingDeleteId = li ? li.dataset.formId : null;
			deletesOrder = root.querySelectorAll(".visa-order-applications__panel").length <= 1;
			if (popup) popup.classList.toggle("is-last", deletesOrder);
		});
	});

	const confirmBtn = document.querySelector("[data-application-delete-confirm]");
	if (confirmBtn) {
		confirmBtn.addEventListener("click", () => {
			if (!pendingDeleteId) return;
			if (deletesOrder) deleteOrder(blockId, confirmBtn);
			else deleteApplication(blockId, pendingDeleteId, confirmBtn);
		});
	}

	initOrderRemove(blockId);
}

// Кнопка «Удалить заказ» над анкетами (XSL рисует её только у черновика). Попап тот
// же, что у карточки в списке заказов, но Orders.js на этой странице не работает
// (там нет .orders__list), поэтому номер в заголовок и обработчик подтверждения
// вешаем здесь.
function initOrderRemove(blockId) {
	const btn = document.querySelector("[data-order-remove]");
	const popup = document.querySelector('[data-popup-name="order-delete"]');
	if (!btn || !popup) return;

	const number = popup.querySelector("[data-order-delete-number]");
	btn.addEventListener("click", () => {
		if (number) number.textContent = btn.dataset.orderNumber ? ` №${btn.dataset.orderNumber}` : "";
	});

	const confirmBtn = popup.querySelector("[data-order-delete-confirm]");
	if (confirmBtn) confirmBtn.addEventListener("click", () => deleteOrder(blockId, confirmBtn));
}

async function addApplication(blockId, btn) {
	btn.disabled = true;
	try {
		const data = new FormData();
		data.set("action", "addForm");
		data.set("block_id", blockId);
		const res = await fetch(`/ajax.php?mid=${ORDER_MID}`, { method: "POST", body: data });
		const json = await res.json();
		if (json.success && json.redirect) { window.location.href = json.redirect; return; }
		console.warn("[order] гость не добавлен:", json.error);
		showAlert(json.error || "Не удалось добавить анкету");
	} catch (e) {
		console.error("[order] ошибка добавления анкеты:", e);
	}
	btn.disabled = false;
}

// Удаление последней анкеты = удаление всего заказа: сервер (action=deleteOrder)
// сам убирает анкеты и их файлы. Возвращаться на страницу удалённого заказа некуда,
// поэтому уходим в список заказов.
async function deleteOrder(blockId, btn) {
	btn.disabled = true;
	try {
		const data = new FormData();
		data.set("action", "deleteOrder");
		data.set("order_id", blockId);
		const res = await fetch(`/ajax.php?mid=${ORDER_MID}`, { method: "POST", body: data });
		const json = await res.json();
		if (json.success) { window.location.href = "/orders/"; return; }
		console.warn("[order] заказ не удалён:", json.error);
		showAlert(json.error || "Не удалось удалить заказ");
	} catch (e) {
		console.error("[order] ошибка удаления заказа:", e);
		showAlert("Не удалось удалить заказ");
	}
	btn.disabled = false;
}

async function deleteApplication(blockId, formId, btn) {
	btn.disabled = true;
	try {
		const data = new FormData();
		data.set("action", "deleteForm");
		data.set("block_id", blockId);
		data.set("form_id", formId);
		const res = await fetch(`/ajax.php?mid=${ORDER_MID}`, { method: "POST", body: data });
		const json = await res.json();
		if (json.success && json.redirect) { window.location.href = json.redirect; return; }
		console.warn("[order] анкета не удалена:", json.error);
		showAlert(json.error || "Не удалось удалить анкету");
	} catch (e) {
		console.error("[order] ошибка удаления анкеты:", e);
	}
	btn.disabled = false;
}
